import styled from '@emotion/styled'

export const Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`

export const Total = styled.div`
  border-top: solid 1px rgb(220, 220, 220);
  display: grid;
  grid-template-columns: 50px 30% auto 120px;
`
